/**
 * Gruppo auto selezionato al banco, inviato a counter-sale-mng come `selectedAcrissSipp`
 * (LPP-24406, ripristina il fix LPP-10644 perso nel 2024).
 *
 * Il `sippCode` serve a NTW per confrontare il gruppo scelto con il SIPP prenotato: senza,
 * una prenotazione su SIPP risulta sempre "cambio gruppo" (upgrade spurio, bloccante sui
 * BeFree 6x6). Usato sia in emissione RA (RaFilling) sia in modifica RA (RaEdit).
 */
export interface ISelectedAcrissSipp {
	code: string;
	description: string;
	sippCode?: string;
}

export const buildSelectedAcrissSipp = (vehicleDetails: any): ISelectedAcrissSipp | null => {
	if (!!vehicleDetails?.plate) {
		return {code: vehicleDetails.plate.acrissCode, description: vehicleDetails.plate.acrissLabel, sippCode: vehicleDetails.plate.sippCode};
	}
	if (!!vehicleDetails?.acriss) {
		return {code: vehicleDetails.acriss.code, description: vehicleDetails.acriss.description, sippCode: vehicleDetails.sipp?.code};
	}
	return null;
};
